export const loadingStrings = {
  loading: 'Loading',
  extra: 'This may take a few seconds.',
};
